// eslint-disable-next-line import/no-cycle
import { postApi } from '@/shared/api';

export default {
	namespaced: true,
	state: () => ({
		offlineASP: null,
	}),
	mutations: {
		setOfflineASPOnlyEsia(state) {
			state.offlineASP = false;
		},
	},
	actions: {
		// eslint-disable-next-line camelcase,no-unused-vars
		async sendPhoneAndBirthday(_, { phone, birthday }) {
			const response = await postApi('/k5/v1/auth/sms/send-code', {
				birthday, phone,
				// birthday: '1972-03-17',
				// phone: '9177975695',
			});
			return response;
		},
		// eslint-disable-next-line camelcase,no-unused-vars
		async sendCode(_, {
			phone, birthday, code, metadata,
		}) {
			const response = await postApi('/k5/v1/auth/sms/validate-code', {
				birthday, phone, code, metadata,
				// birthday: '1972-03-17',
				// phone: '9177975695',
				// code,
			});
			return response;
		},
	},

};
